import React, { useState } from "react";
import styled from "styled-components";
import { lightThemeColors } from "../../assets/styles/colors";
import LinksOverview from "./LinksOverview";
import LinksView from "./LinksView";
import CustomSearchInput from "../../components/linksComponents/CustomSearchInput";
import DatePickerWithOptions from "../../components/linksComponents/DatePickerWithOptions";
import AdsPlatformFilter from "./AdsPlatformFilter";

const LinksPageContent = ({
  startDate,
  setStartDate,
  endDate,
  setEndDate,
  totalPages,
  setPage,
  page,
  setSort,
  setSearchInputvalue,
  searchInputValue,
  linksWithMetrics,
  sort,
  handleSearchInputValue,
  handleEditLink,
  linksType,
  adsFilter,
  setAdsFilter,
  adsFilterOptions,
  campaignID,
  months,
  setMonths,
  handleOptionSelect,

}) => {
  return (
    <Container>
      <Line style={{ zIndex: "3" }}>
        <CustomSearchInput
          style={{ maxWidth: "300px" }}
          value={searchInputValue}
          setValue={handleSearchInputValue}
          palceholder="Search"
        />
        <AdsPlatformFilter
          filterOptions={adsFilterOptions}
          selectedMetrics={adsFilter}
          setSelectedMetrics={setAdsFilter}
        />
        <Line style={{ marginLeft: "auto" }}>
          <DatePickerWithOptions
            startDate={startDate}
            setStartDate={setStartDate}
            endDate={endDate}
            setEndDate={setEndDate}
            months={months}
            setMonths={setMonths}
            handleOptionSelect={handleOptionSelect}
          />
        </Line>
      </Line>

      <LinksOverview
        startDate={startDate}
        endDate={endDate}
        linksType={linksType}
        linksOverview={true}
        adsPlatform={adsFilter}
        campaignID={campaignID}
      />
      <Separator />
      <LinksView
        totalPages={totalPages}
        setPage={setPage}
        page={page}
        setSort={setSort}
        linksWithMetrics={linksWithMetrics}
        sort={sort}
        handleEditLink={handleEditLink}
        adsFilter={adsFilter}
        setAdsFilter={setAdsFilter}
      />
    </Container>
  );
};

export default LinksPageContent;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;

  h2 {
    width: 100%;
  }
  gap: 30px;
`;

const Separator = styled.div`
  display: flex;
  height: 1px;
  min-height: 1px;
  width: 100%;
  background: ${lightThemeColors.darkColor};
  opacity: 0.1;
`;
const Line = styled.div`
  display: flex;
  gap: 20px;
  align-items: center;
  position: relative;
`;
